module.exports = new __parcel__URL__("shop_machines_sunday_skirmish_trophy.58620836.png").toString();